import Client from '../../../utils/ClientVOIM';
import URL from '../../../utils/URL';
import { myLog } from '../../../utils/Utility';

export function getFinancialReportSessionWise(values, fromDate, toDate, callBack) {
    return function () {
        Client.get(
            `${URL.IM_EDUCATOR.GET_FINANCIAL_REPORT_SESSION_WISE}?startDate=${fromDate}&endDate=${toDate}`,
            values,
            true
        )
            .then((response) => {
                myLog('====financial report session wise response===::::', response);
                callBack(response);
            })
            .catch((error) => {
                myLog('====financial report session wise response===::::', error);
                callBack(false);
            });
    };
}

export const getFinancialReportPayoutHistory = (values, fromDate, toDate, callBack) => {
    return function () {
        Client.get(
            `${URL.IM_EDUCATOR.GET_FINANCIAL_REPORT_PAYOUT_HISTORY}?startDate=${fromDate}&endDate=${toDate}`,
            values,
            true
        )
            .then((response) => {
                myLog('====financial report session wise response===::::', response);
                callBack(response);
            })
            .catch((error) => {
                myLog('====financial report session wise error===????', error);
                callBack(false);
            });
    };
};

// need to integrate for the stripe acc and balance
export function getStripeAccountDetails(callBack) {
    return function () {
        Client.get(URL.IM_EDUCATOR.GET_FINANCIAL_REPORT_STRIPE_DETAILS, null, true)
            .then((response) => {
                callBack(response);
            })
            .catch((error) => {
                myLog('====DashDetails error===????', error);
                callBack(false);
            });
    };
}

// setup stripe connection
export function setupStripConnection(callBack) {
    return function () {
        Client.post(URL.IM_EDUCATOR.SETUP_STRIPE_CONNECTION, null, true)
            .then((response) => {
                callBack(response);
            })
            .catch((error) => {
                myLog('====Stripe connection error===????', error);
                callBack(false);
            });
    };
}

// fund transfer from available balance
export function educatorFundTransfer(values, callBack) {
    return function () {
        Client.post(URL.IM_EDUCATOR.EDUCATOR_FUND_TRANSFER, values, true)
            .then((response) => {
                callBack(response);
            })
            .catch((error) => {
                myLog('====fund transfer from available balance error===????', error);
                callBack(false);
            });
    };
}
